export default {"src":"/_next/static/media/ic-home-mobile.b06b8c4f.svg","height":21,"width":22,"blurWidth":0,"blurHeight":0};